import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { Save, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function SettingsAdmin() {
  const [s, setS] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => { api.get("/settings").then((r) => setS(r.data)).catch(() => {}); }, []);
  if (!s) return <div>Loading...</div>;

  const upd = (k, v) => setS({ ...s, [k]: v });

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { await api.put("/admin/settings", s); toast.success("Settings updated"); }
    catch { toast.error("Failed"); }
    finally { setBusy(false); }
  };

  const FIELDS = [
    { k: "phone", l: "Phone" },
    { k: "whatsapp", l: "WhatsApp (incl. country code)" },
    { k: "email", l: "Email" },
    { k: "address", l: "Address" },
    { k: "facebook", l: "Facebook URL" },
    { k: "twitter", l: "Twitter / X URL" },
    { k: "instagram", l: "Instagram URL" },
    { k: "linkedin", l: "LinkedIn URL" },
    { k: "youtube", l: "YouTube URL" },
  ];

  return (
    <div data-testid="admin-settings" className="space-y-8">
      <header><div className="label-eyebrow mb-2">Manage</div>
        <h1 className="font-display text-4xl text-[hsl(var(--primary))]">Site Settings</h1></header>

      <form onSubmit={save} className="bg-white border border-[hsl(var(--border-c))] p-6 space-y-5">
        <h2 className="font-display text-2xl text-[hsl(var(--primary))]">Homepage</h2>
        <div><Label>Hero Title</Label><Input value={s.hero_title} onChange={(e) => upd("hero_title", e.target.value)} data-testid="set-hero-title" /></div>
        <div><Label>Hero Slogan</Label><Input value={s.hero_slogan} onChange={(e) => upd("hero_slogan", e.target.value)} /></div>
        <div><Label>Hero Subtitle</Label><Textarea rows={2} value={s.hero_subtitle} onChange={(e) => upd("hero_subtitle", e.target.value)} /></div>

        <h2 className="font-display text-2xl text-[hsl(var(--primary))] pt-6">Contact & Social</h2>
        <div className="grid sm:grid-cols-2 gap-4">
          {FIELDS.map((f) => (
            <div key={f.k}>
              <Label>{f.l}</Label>
              <Input value={s[f.k] || ""} onChange={(e) => upd(f.k, e.target.value)} data-testid={`set-${f.k}`} />
            </div>
          ))}
        </div>

        <Button type="submit" disabled={busy} data-testid="set-save"
          className="bg-[hsl(var(--primary))] hover:bg-[hsl(var(--primary-hover))] rounded-none uppercase tracking-widest">
          {busy ? <Loader2 size={14} className="animate-spin mr-2" /> : <Save size={14} className="mr-2" />}
          Save Settings
        </Button>
      </form>
    </div>
  );
}
